import React from 'react';
import { RadioField, Step } from '../SteppedForm';

const StepOnboardvehicle = (props) => {
  return (
    <Step
      id="onboardvehicle"
      title={'Onboard Vehicle #' + (props.state.vehicle_index + 1)}
      skip={() => props.state.formdata.tiger === true}>
      <RadioField
        id="carbuyfin"
        required
        defaultValue="carfin"
        options={props.carFinOptions}
        filterOut={(key) => {
          if (key === 'none' && props.state.formdata.vehicles.length > 1) return true;
          return props.inStates(['sa']) || props.inNetworks(['CHAMP'])
            ? ['buyfin', 'buy', 'fin'].indexOf(key) >= 0
            : false;
        }}
      />
    </Step>
  );
};

export default StepOnboardvehicle;
